export default {
  namespaced: true,
  state: {
    id: {
      type: String
    },
    status: {
      type: String
    },
    formColor: {
      type: String
    }
  },
  getters: {
    CURRENTMOCID: state => {
      return state.id
    },
    CURRENTMOCSTATUS: state => {
      return state.status
    },
    FORMCOLOR: state => {
      return state.formColor
    }
  },
  mutations: {
    SET_CURRENT_MOC_ID(state, payload) {
      state.id = payload
    },
    SET_CURRENT_MOC_STATUS(state, payload) {
      state.status = payload
    },
    SET_FORM_COLOR(state, payload) {
      state.formColor = payload
    }
  },
  actions: {
    setId: ({ commit, state }, newValue) => {
      commit('SET_CURRENT_MOC_ID', newValue)
      return state.id
    },
    setStatus: ({ commit, state }, newValue) => {
      commit('SET_CURRENT_MOC_STATUS', newValue)
      return state.status
    },
    setFormColor: ({commit, state}, newValue) => {
      commit('SET_FORM_COLOR', newValue)
      return state.formColor
    }
  }
}
